import React from 'react';

interface WhatsAppIconProps {
  w?: number;
  h?: number;
  disabled?: boolean;
}

export function WhatsAppIcon({ w = 16, h = 16, disabled = false }: WhatsAppIconProps) {
  return (
    <svg
      width={w}
      height={h}
      opacity={disabled ? 0.5 : 1}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2_6531)">
        <path
          d="M12.0173 0.0439785C5.43521 0.0439785 0.082432 5.39481 0.0800905 11.9718C0.076849 14.2176 0.709285 16.4185 1.90429 18.3201L2.18819 18.7714L0.98253 23.173L5.49882 21.9888L5.93492 22.2471C7.76653 23.3341 9.86663 23.909 12.0083 23.9101H12.0128C18.5898 23.9101 23.9425 18.5587 23.9451 11.9813C23.95 10.4137 23.644 8.86055 23.0446 7.41195C22.4453 5.96335 21.5645 4.64802 20.4534 3.54212C19.3484 2.43018 18.0338 1.54846 16.5857 0.947996C15.1377 0.347537 13.5849 0.0402684 12.0173 0.0439785Z"
          fill="url(#paint0_linear_2_6531)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.42568 5.97087C8.1568 5.3736 7.87387 5.36151 7.61846 5.35116L6.93085 5.34277C6.69163 5.34277 6.30295 5.43253 5.97436 5.79155C5.64577 6.15058 4.71875 7.01829 4.71875 8.78316C4.71875 10.548 6.00421 12.2534 6.18334 12.493C6.36246 12.7326 8.6649 16.4698 12.3111 17.9077C15.3412 19.1026 15.9578 18.8649 16.6157 18.8052C17.2737 18.7455 18.7381 17.9375 19.0368 17.0998C19.3355 16.2622 19.3357 15.5445 19.2462 15.3945C19.1566 15.2444 18.9174 15.1553 18.5584 14.9757C18.1993 14.7962 16.436 13.9285 16.1072 13.8087C15.7785 13.6889 15.5394 13.6294 15.3 13.9884C15.0606 14.3475 14.374 15.1551 14.1646 15.3945C13.9552 15.6339 13.7463 15.6639 13.3872 15.4846C13.0282 15.3053 11.8731 14.9264 10.5026 13.7043C9.43621 12.7535 8.71641 11.5793 8.50685 11.2204C8.29729 10.8616 8.4846 10.6673 8.66451 10.4885C8.82548 10.3277 9.02314 10.0696 9.20285 9.86024C9.38256 9.65087 9.44168 9.50121 9.56109 9.26219C9.68051 9.02316 9.621 8.81321 9.53124 8.6339C9.44148 8.45458 8.74451 6.68033 8.42568 5.97087Z"
          fill="white"
        />
      </g>
    </svg>
  );
}
